import create from "zustand";
import { produce } from "immer";
import {
  EdgeSystemState,
  EdgeSystemStatus,
  EdgeSystemType,
  SystemState,
} from "../types";
import { defaultSystemState } from "../utils/systemUtils";

export interface ISystemStateStore {
  initialSyncStatus: EdgeSystemStatus;
  setInitialSyncStatus: (initialSyncStatus: EdgeSystemStatus) => void;

  systemState: SystemState;
  setSystemState: (systemState: SystemState) => void;
  updateSystemState: (state: EdgeSystemState) => void;
}

export const useSystemStateStore = create<ISystemStateStore>(
  (setState, getState) => ({
    initialSyncStatus: EdgeSystemStatus.Initial,
    setInitialSyncStatus: (initialSyncStatus: EdgeSystemStatus) =>
      setState({ initialSyncStatus }),

    systemState: defaultSystemState,
    setSystemState: (systemState: SystemState) => setState({ systemState }),
    updateSystemState: (payload: EdgeSystemState) => {

      setState(
        produce(getState(), (currentState) => {
          currentState.systemState[payload.systemType] = payload;

          // update the initial sync status if the system type is DataSync and the current initial sync status is not Success
          if (
            payload.systemType === EdgeSystemType.DataSync &&
            currentState.initialSyncStatus !== EdgeSystemStatus.Success
          ) {
            currentState.initialSyncStatus = payload.status;
          }
        })
      );
    },
  })
);
